/* Inheritance Jewelry - Scroll-triggered fade-in animations.
   Adds .ij-in-view class when element enters viewport. Keeps CSS simple. */
(function () {
  'use strict';

  // Respect reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var candidates = [
    '.shopify-section',
    '.ij-review-card',
    '.ij-usp',
    '.resource-card',
    '.product-card',
    '.collection-card'
  ];

  // Tag everything we want to animate
  function tag() {
    candidates.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('ij-anim')) {
          el.classList.add('ij-anim');
        }
      });
    });
  }

  function setupObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.ij-anim').forEach(function (el) {
        el.classList.add('ij-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ij-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.ij-anim').forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    tag();
    setupObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
